import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { LISTINGS_MANAGEMENT_DASHBOARD_QUERY_KEY } from '@/config/appSettingsKeys'

export interface ListingsManagementDashboard {
  folders_json: unknown
  processed_folder_id: string | null
  listings_management_v2_enabled: boolean
  last_refresh_id: string | null
  last_refresh_status: string | null
  last_refresh_started_at: string | null
  last_refresh_finished_at: string | null
  last_refresh_files_succeeded: number | null
  last_refresh_files_failed: number | null
  last_refresh_files_skipped: number | null
  epg_last_success_at: string | null
  epg_last_status: string | null
  epg_last_error: string | null
  streaming_row_count: number | null
  streaming_last_run_at: string | null
  streaming_last_run_error: string | null
}

export function useListingsManagementDashboard(enabled: boolean) {
  return useQuery({
    queryKey: LISTINGS_MANAGEMENT_DASHBOARD_QUERY_KEY,
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_listings_management_dashboard')
      if (error) throw error
      const row = Array.isArray(data) ? data[0] : data
      return row as ListingsManagementDashboard | null
    },
    enabled,
    staleTime: 30_000,
  })
}
